import { http, queryString } from 'utils'
import { InvoiceDecorator } from 'decorators'
import { map, omit, concat } from 'lodash'

// Invoice mutation imports.
import {
  SET_INVOICES, SET_INVOICES_PAGINATION, ADD_INVOICES, SET_INVOICE, RESET_INVOICE
} from 'vx/mutations'

const initialInvoiceState = () => {
  return {
    id: null,
    user_id: null,
    xero_number: null
  }
}

// Invoice state.
const state = {
  invoices: [],
  invoice: initialInvoiceState()
}

// Invoice state getters.
const getters = {
  /**
   * Invoices decorated via the InvoiceDecorator.
   */
  invoicesDecorated: state => map(state.invoices, invoice => (new InvoiceDecorator(invoice))),

  /**
   * Decorated load.
   */
  invoiceDecorated: state => (new InvoiceDecorator(state.invoice)),

  /**
   * Determine if we have an invoice.
   */
  haveInvoice: state => state.invoice.id !== null && state.invoice.id !== undefined
}

// Invoice actions.
const actions = {
  /**
   * Get a list of invoices based on user.
   */
  getInvoices ({ commit }, payload) {
    return http.get(`invoices?${queryString(payload)}`).then(response => {
      commit(SET_INVOICES, response.data.data)
      commit(SET_INVOICES_PAGINATION, omit(response.data, 'data'))

      return response
    })
  },

  /**
   * Get the invoices for the next page.
   */
  getInvoicesForNextPage ({ commit, state }, payload) {
    if (state.pagination.current_page === state.pagination.last_page || state.pagination.total === 0) {
      return Promise.reject('There are no more invoices to load.')
    }

    let page = state.pagination.current_page + 1

    return http.get(`invoices?${queryString(payload)}&page=${page}`).then(response => {
      commit(ADD_INVOICES, response.data.data)
      commit(SET_INVOICES_PAGINATION, omit(response.data, 'data'))

      return response
    })
  },

  /**
   * Get invoice by id
   */
  getInvoice ({ commit }, id) {
    return http.get(`invoices/${id}`).then(response => {
      commit(SET_INVOICE, response.data)

      return response
    })
  },

  /**
   * Sync invoice by id
   */
  syncInvoice ({ commit }, id) {
    return http.post(`invoices/${id}/sync`)
  },

  /**
   * Get invoice by public id
   */
  getInvoiceByPublicId ({ commit }, id) {
    return http.get(`invoices/${id}/public`).then(response => {
      commit(SET_INVOICE, response.data)

      return response
    })
  }
}

// Invoice state mutations.
const mutations = {
  /**
   * Set the invoices.
   */
  [SET_INVOICES] (state, invoices) {
    state.invoices = invoices
  },

  /**
   * Set the driver pagination.
   */
  [SET_INVOICES_PAGINATION] (state, pagination) {
    state.pagination = pagination
  },

  /**
   * Add more invoices to the invoices state.
   */
  [ADD_INVOICES] (state, invoices) {
    state.invoices = concat(state.invoices, invoices)
  },

  /**
   * Add more invoices to the invoices state.
   */
  [SET_INVOICE] (state, invoice) {
    state.invoice = invoice
  },

  /**
   * Reset the load.
   */
  [RESET_INVOICE] (state) {
    state.invoice = initialInvoiceState()
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/invoice.js